export const LAIA_HEADER_TITLE = 'LAIA Genesis • C6'
